import { c as _c } from "react/compiler-runtime";
import { PassengerCountInitialValuesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { useState } from "react";
export const usePassengerCount = initialValues => {
  const $ = _c(22);
  const router = useRouter();
  const t0 = initialValues?.adult || 1;
  const t1 = initialValues?.child || 0;
  const t2 = initialValues?.room || 1;
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      adult: t0,
      child: t1,
      room: t2
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState(t3);
  const [passengerCount, setPassengerCount] = useState(temporaryPassengerCount);
  const {
    adult,
    child,
    room
  } = temporaryPassengerCount;
  const total = adult + child;
  const remain = 15 * room - total;
  const remainNotAdult = Math.min(remain, adult * 12 - child);
  const adultMax = adult + remain;
  const childMax = child + remainNotAdult;
  const roomMax = process.env.NEXT_PUBLIC_APP_NAME === "hotel-international" ? 1 : 15;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setTemporaryPassengerCount(state => {
        setPassengerCount(state);
        return state;
      });
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onSubmitPassengerCount = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = value => {
      setTemporaryPassengerCount(state_0 => ({
        ...state_0,
        room: value
      }));
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const onChangeRoom = t5;
  const t6 = room >= roomMax;
  const t7 = room <= 1;
  let t8;
  if ($[6] !== room || $[7] !== t6 || $[8] !== t7) {
    t8 = [{
      increaseDisabled: t6,
      decreaseDisabled: t7,
      title: "\u062A\u0639\u062F\u0627\u062F \u0627\u062A\u0627\u0642",
      value: room,
      onChange: onChangeRoom
    }];
    $[6] = room;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const list = t8;
  let t9;
  if ($[10] !== passengerCount.room || $[11] !== router.locale) {
    t9 = numberConvert(passengerCount.room, {
      locale: router.locale
    });
    $[10] = passengerCount.room;
    $[11] = router.locale;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `${t9} اتاق`;
  const t11 = adult >= adultMax;
  const t12 = child >= childMax;
  const t13 = !(room * 15 >= total);
  let t14;
  if ($[13] !== t11 || $[14] !== t12 || $[15] !== t13) {
    t14 = {
      isPassengerDisabled: t11,
      isChildrenDisabled: t12,
      isSubmitDisabled: t13
    };
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== list || $[18] !== passengerCount || $[19] !== t10 || $[20] !== t14) {
    t15 = {
      passengerCountTitle: "\u062A\u0639\u062F\u0627\u062F \u0627\u062A\u0627\u0642",
      passengerCountResult: t10,
      passengerCountList: list,
      passengerCount,
      onSubmitPassengerCount,
      passengerCountValidation: t14
    };
    $[17] = list;
    $[18] = passengerCount;
    $[19] = t10;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
};